import { useEffect, useRef } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Scrolls to the top of the page on every client-side route change.
 *
 * Skips when:
 *  - the URL has a hash (let the browser jump to the anchor instead)
 *  - the navigation is POP (browser back/forward) so the user keeps their place
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()
  const previousPathnameRef = useRef(pathname)

  useEffect(() => {
    const samePath = previousPathnameRef.current === pathname
    previousPathnameRef.current = pathname

    if (samePath) return
    if (navigationType === 'POP') return
    if (hash) return

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash, navigationType])

  return null
}
